import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { AppDispatch, RootState } from "../../../Redux/store";
import { logoutUser } from "../../../Redux/Auth/AuthActions";
import { useDispatch, useSelector } from "react-redux";
import { RxHamburgerMenu } from "react-icons/rx";
import styles from "./MobileHeader.module.scss";
import useClick from "../../../Util/useClick";
import Logo from "../../../Assets/Logo.png";
import { FaRegBell } from "react-icons/fa";
import Sidebar from "../Sidebar/Sidebar";
import { Link } from "react-router";
import React from "react";

function MobileHeader() {
  const dispatch = useDispatch<AppDispatch>();
  const { user, token } = useSelector((state: RootState) => state.auth);
  const { ref, isActive, setIsActive } = useClick(false);
  return (
    <React.Fragment>
      <div
        className={`${styles.sidebarOverlayContainer} ${isActive ? styles.sidebarOverlayContainerActive : ""}`}
      >
        <div
          ref={ref}
          className={`${styles.sidebarContainer} ${isActive ? styles.sidebarContainerActive : ""}`}
        >
          <Sidebar />
        </div>
      </div>
      <div className={styles.mainContainer}>
        {user && token && (
          <div className={styles.iconContainer}>
            <RxHamburgerMenu
              className={styles.icon}
              onClick={() => setIsActive(true)}
            />
          </div>
        )}
        <div className={styles.logoContainer}>
          <img src={Logo} alt="logo" />
        </div>
        {!user && !token && (
          <div className={styles.menuContainer}>
            <a href="mailto:info@amenigies.com">
              <button className={styles.loginButton}>Contact US</button>
            </a>
            <Link className={styles.loginButton} to="/login" replace>
              Login
            </Link>
          </div>
        )}
        {user && token && (
          <div className={styles.menuContainer}>
            <div className={styles.notificationContainer}>
              <FaRegBell className={styles.icon} />
            </div>

            <Menu
              menuButton={
                <MenuButton>
                  <div className={styles.menuItem}>
                    {user && (
                      <p>
                        {user?.member?.firstName?.[0] +
                          user?.member?.lastName?.[0]}
                      </p>
                    )}
                  </div>
                </MenuButton>
              }
              transition
            >
              <MenuItem onClick={() => dispatch(logoutUser())}>Logout</MenuItem>
            </Menu>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default MobileHeader;
